import { createAsyncThunk } from '@reduxjs/toolkit';
import { ArticleCategory, QueryParams } from '../../types';
import { Paginated, PaginationService } from '../../services/api-handlers/pagination';
import { ArticleCategoryApi } from '../../services/end-points';
import SortingService from '../../services/sorting';
import { ThunkConfig } from '../configure-store';

export const listArticleCategories = createAsyncThunk<Paginated<ArticleCategory>, QueryParams, ThunkConfig>(
    'article-category/list',
    async (payload, thunkApi) => {
        const { getState } = thunkApi;
        const { articleCategory } = getState();
        const { filters, sorting, ...rest } = payload;

        return PaginationService.resolveApiCall(
            thunkApi,
            articleCategory,
            async () =>
                ArticleCategoryApi.list({
                    ...filters,
                    ...SortingService.makeOrder(sorting),
                    ...rest,
                }),
            payload.page,
            articleCategory.data,
        );
    },
);

export const getAllArticleCategories = createAsyncThunk<Paginated<ArticleCategory>, undefined, ThunkConfig>(
    'article-category/all-list',
    async (payload, thunkApi) => {
        const { getState } = thunkApi;
        const { articleCategory } = getState();

        return PaginationService.resolveApiCall(
            thunkApi,
            articleCategory,
            async () =>
                ArticleCategoryApi.list({
                    limit: -1,
                }),
            1,
            {
                list: [],
                page: 1,
            },
        );
    },
);
